module.exports = __webpack_public_path__ + "assets/img/logo-lecard.066b7e15.png";